module.exports = __webpack_public_path__ + "img/146ne.61482843.svg";